import {
  ATTACHMENT_EXTENSIONS,
  ATTACHMENT_MAX_NUM,
  ATTACHMENT_MAX_SIZE,
  ErrorMessages,
} from 'constants/Attachment'

import type { EditBookingAttachment } from './editBookingValidation'

export type ValidateAttachmentsResult = { ok: true } | { ok: false; message: string }

const interpolate = (template: string, vars: Record<string, string>): string =>
  template.replace(/\$\{(\w+)\}/g, (_, key) => vars[key] ?? '')

export const validateAttachments = (
  attachments: readonly EditBookingAttachment[],
  files: readonly File[]
): ValidateAttachmentsResult => {
  const totalFileLength = attachments.length + files.length
  if (totalFileLength > ATTACHMENT_MAX_NUM) {
    return { ok: false, message: ErrorMessages.OVER_MAX_COUNT }
  }

  const oversized = files.find((file) => file.size >= ATTACHMENT_MAX_SIZE)
  if (oversized) {
    return {
      ok: false,
      message: interpolate(ErrorMessages.OVER_MAX_SIZE, { fileName: oversized.name }),
    }
  }

  const invalidExt = files.find((file) => {
    const parts = file.name.split('.')
    const ext = parts[parts.length - 1].toLowerCase()
    return !ATTACHMENT_EXTENSIONS.includes(`.${ext}`)
  })
  if (invalidExt) {
    return {
      ok: false,
      message: interpolate(ErrorMessages.INVALID_FILE_TYPE, { fileName: invalidExt.name }),
    }
  }

  if (files.some((f) => f.name.includes(','))) {
    return { ok: false, message: ErrorMessages.INVALID_FILE_NAME }
  }

  const duplicated = files.some((file) => attachments.some((a) => a.name === file.name))
  if (duplicated) {
    return { ok: false, message: ErrorMessages.DUPLICATED_FILE_NAME }
  }

  return { ok: true }
}
